import React, { useEffect, useState } from "react";
import HeroSection from "../Components/HeroSection";
import CarouselSection from "../Components/CarouselSection";
import FeaturesSection from "../Components/FeaturesSection";
import FAQSection from "../Components/FAQSection";
import CTASection from "../Components/CTASection";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const carouselItems = [
    {
      title: "Admin Panel",
      desc: "Manage the entire school system, user roles, and configurations.",
      img: "https://ik.imagekit.io/gqpk1bdvr/Admin_dashboard.jpeg",
    },
    {
      title: "Teachers Panel",
      desc: "Handle attendance, lesson plans, and communication with students.",
      img: "https://ik.imagekit.io/gqpk1bdvr/Teacher_Panel.jpeg",
    },
    {
      title: "Students Panel",
      desc: "Track attendance, grades, and participate in school activities.",
      img: "https://ik.imagekit.io/gqpk1bdvr/StudentPanel_Dashboard.jpeg",
    },
    {
      title: "Library Panel",
      desc: "Manage book catalog, issue/return records, and digital resources.",
      img: "https://ik.imagekit.io/gqpk1bdvr/Admin_dashboard.jpeg",
    },
  ];

  const features = [
    {
      icon: (
        <img
          src="https://cdn-icons-png.flaticon.com/512/4472/4472589.png"
          alt="Centralised Data"
          className="w-12 h-12 mx-auto"
        />
      ),
      title: "Centralised Data Management",
      desc: "ERP systems gather all your school’s data into a single central database, ensuring consistency and eliminating data silos.",
    },
    {
      icon: (
        <img
          src="https://cdn-icons-png.flaticon.com/512/2920/2920244.png"
          alt="Digital Content Delivery"
          className="w-12 h-12 mx-auto"
        />
      ),
      title: "Digital Content Delivery",
      desc: "Share educational materials, assignments, and communications digitally with students, teachers, and parents.",
    },
    {
      icon: (
        <img
          src="https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
          alt="Personalised Portals"
          className="w-12 h-12 mx-auto"
        />
      ),
      title: "Personalised Portals",
      desc: "Custom dashboards showcasing tools tailored to the unique needs and preferences of each user.",
    },
    {
      icon: (
        <img
          src="https://cdn-icons-png.flaticon.com/512/2721/2721298.png"
          alt="Real-Time Reporting"
          className="w-12 h-12 mx-auto"
        />
      ),
      title: "Real-Time Reporting & Analytics",
      desc: "Monitor school performance through real-time dashboards and custom reports for smarter decisions.",
    },
    {
      icon: (
        <img
          src="https://cdn-icons-png.flaticon.com/512/9181/9181808.png"
          alt="Support and Training"
          className="w-12 h-12 mx-auto"
        />
      ),
      title: "Robust Support & Training",
      desc: "Get reliable help anytime through chat, email, or phone to ensure smooth and effective operations.",
    },
    {
      icon: (
        <img
          src="https://cdn-icons-png.flaticon.com/512/3176/3176362.png"
          alt="Friendly Interface"
          className="w-12 h-12 mx-auto"
        />
      ),
      title: "Friendly Interface",
      desc: "An intuitive, easy-to-navigate design for teachers, students, parents, and administrators.",
    },
  ];

  const accordionData = [
    {
      title: "How does student attendance work?",
      content:
        "Attendance can be tracked by parents digitally. Teachers can mark attendance digitally, and parents receive instant absence alerts.",
    },
    {
      title: "Can teachers upload grades online?",
      content:
        "Yes, teachers can easily upload grades and remarks through the portal. Students and parents can view results in real-time, promoting transparency and quick feedback.",
    },
    {
      title: "Is the ERP cloud-based?",
      content:
        "Yes, our ERP is 100% cloud-based and accessible from any device. It ensures secure, real-time access for admins, teachers, and parents—anywhere, anytime.",
    },
    {
      title: "Does the system manage school events?",
      content:
        "Absolutely! Schools can create, schedule, and publish events with reminders. Teachers and students receive instant notifications for upcoming programs or meetings.",
    },
    {
      title: "Can parents access their child’s academic progress?",
      content:
        "Parents get a personalized login to track attendance, grades, and homework. They can stay connected with teachers and follow every aspect of their child’s progress.",
    },
    {
      title: "Does the ERP integrate with existing systems?",
      content:
        "Yes, it integrates smoothly with finance tools and learning platforms. No need to change your existing systems.",
    },
    {
      title: "How secure is the data stored in the ERP?",
      content:
        "Your data is fully encrypted and stored on secure servers with daily backups. We follow strict privacy standards to keep every record safe and confidential.",
    },
  ];

  // Carousel auto-slide
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection(1);
      setIndex((prev) => (prev + 1) % carouselItems.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [carouselItems.length]);

  return (
    <div>

      <>
  <Helmet>

    <title>
      Gurukul ERP – Smart School Management Software for Indian Schools
    </title>

    <meta
      name="description"
      content="Gurukul ERP is a modern school management software for Indian schools. Manage attendance, fees, exams, student records, communication, and administration through one smart cloud-based ERP platform."
    />

    <meta
      name="keywords"
      content="School ERP Software, School Management Software, Gurukul ERP, CBSE School ERP, Attendance Management System, Fee Management Software, Student Management System"
    />

    <meta name="robots" content="index, follow" />

    <link rel="canonical" href="https://gurukulerp.in/" />

    {/* Open Graph */}
    <meta
      property="og:title"
      content="Gurukul ERP – School Management Software"
    />

    <meta
      property="og:description"
      content="Manage attendance, fees, exams, communication, and school administration with Gurukul ERP."
    />

    <meta
      property="og:url"
      content="https://gurukulerp.in/"
    />

    <meta
      property="og:image"
      content="https://gurukulerp.in/og-image.jpg"
    />

    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />

    <meta
      name="twitter:title"
      content="Gurukul ERP – Smart School ERP"
    />

    <meta
      name="twitter:description"
      content="Cloud-based school management software for Indian schools."
    />

    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: "Gurukul ERP",
        applicationCategory: "School Management Software",
        operatingSystem: "Web",
        url: "https://gurukulerp.in",
      })}
    </script>

  </Helmet>

  <div>
    {/* Your existing homepage */}
  </div>
</>

      <HeroSection />
      <div style={{ minHeight: 420 }}>
        <CarouselSection
          carouselItems={carouselItems}
          index={index}
          setIndex={setIndex}
          direction={direction}
        />

      </div>



      {/* ================= ERP TRUST SECTION ================= */}
<section className="py-20 bg-[#f4f7fb]">
  <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

    {/* LEFT CONTENT */}
    <div>
      <h3 className="text-[#0c5a87] text-lg mb-2">
        Why Gurukul School ERP
      </h3>

      <h2 className="text-4xl font-semibold text-[#0c5a87] mb-4">
        One Platform for Complete <span className="text-orange-500">School Management</span>
      </h2>

      <p className="text-gray-600 text-sm leading-relaxed mb-6">
        Gurukul ERP helps CBSE schools and education institutes manage academic,
        administrative, and financial operations through a single cloud-based
        platform. Designed for modern institutions, it simplifies daily workflows,
        improves communication, and provides real-time insights without complexity.
      </p>

      <a
        href="/contact"
        className="inline-block bg-gradient-to-r from-orange-500 to-yellow-400 text-white px-7 py-3 rounded-full font-medium"
      >
        Get Free Demo
      </a>
    </div>

    {/* RIGHT IMAGES */}
    <div className="flex justify-center gap-4">
      <img
  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
  alt="Students using school ERP system"
  className="w-28 h-72 object-cover rounded-2xl"
/>

<img
  src="https://images.unsplash.com/photo-1509062522246-3755977927d7"
  alt="Modern education technology platform"
  className="w-32 h-80 object-cover rounded-2xl"
/>

<img
  src="https://images.unsplash.com/photo-1523240795612-9a054b0db644"
  alt="School management software users"
  className="w-28 h-72 object-cover rounded-2xl"
/>
    </div>

  </div>
</section>


      <FeaturesSection features={features} />

      {/* ================= INTEGRATION SECTION ================= */}
<section className="py-20 bg-gray-50">
  <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

    {/* LEFT IMAGE */}
<div className="flex justify-center">
  <img
    src="ChatGPT Image Feb 26, 2026, 03_35_07 PM.png"
    alt="Integration"
    className="w-[500px] md:w-[650px] lg:w-[750px] object-contain"
  />
</div>


    {/* RIGHT CONTENT */}
    <div>
      <p className="text-sm text-gray-500 mb-2">Integration</p>

      <h2 className="text-3xl font-semibold mb-4 text-orange-500">
        Have Seamless Communication Through Modern ERP Messaging
      </h2>

      <h3 className="text-2xl font-semibold mb-3 text-gray-800">
        Smart Communication For Education
      </h3>

      <p className="text-gray-600 text-sm leading-relaxed mb-6">
        Improve communication between schools, teachers, students, and parents
        through integrated messaging tools. Gurukul ERP helps institutions
        manage announcements, updates, and academic information in real-time
        without switching platforms.
      </p>

      <a
        href="/contact"
        className="inline-block bg-gradient-to-r from-orange-500 to-yellow-400 text-white px-6 py-3 rounded-full"
      >
        Explore Now
      </a>
    </div>

  </div>
</section>


      <FAQSection accordionData={accordionData} />
      <CTASection />
    </div>
  );
};

export default Home;
